import React from 'react';

const AdminQuestionsEditModal = ({
  visible,
  editingQuestion,
  formData,
  submitting,
  onClose,
  onChange,
  onSubmit
}) => {
  if (!visible || !editingQuestion) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75 flex items-center justify-center z-50 overflow-y-auto">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-2xl w-full mx-4 my-8">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Edit Question</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Industry & Region
            </label>
            <input
              type="text"
              value={`${formData.industry_name || 'N/A'} (${(formData.question_region || 'N/A').toUpperCase()})`}
              disabled
              className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
            />
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Industry and region cannot be changed
            </p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
              Question Text *
            </label>
            <textarea
              name="question_text"
              value={formData.question_text}
              onChange={onChange}
              required
              rows="3"
              className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Question Code *
              </label>
              <input
                type="text"
                name="question_code"
                value={formData.question_code}
                onChange={onChange}
                required
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Question Type *
              </label>
              <select
                name="question_type"
                value={formData.question_type}
                onChange={onChange}
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              >
                <option value="numeric">Numeric</option>
                <option value="boolean">Boolean</option>
                <option value="yes_no">Yes/No</option>
                <option value="multiple_choice">Multiple Choice</option>
                <option value="text">Text</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Category *
              </label>
              <input
                type="text"
                name="category"
                value={formData.category || ''}
                onChange={onChange}
                required
                placeholder="e.g., Process Heating, HVAC, Lighting"
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              />
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                Required: Category is mandatory for all questions
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Subcategory
              </label>
              <input
                type="text"
                name="subcategory"
                value={formData.subcategory}
                onChange={onChange}
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              />
            </div>
          </div>
          {(formData.question_type === 'multiple_choice' || 
            formData.question_type === 'boolean' || 
            formData.question_type === 'yes_no') && (
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Options {formData.question_type === 'multiple_choice' ? '(comma-separated)' : '(optional, defaults to Yes/No if empty)'}
              </label>
              <input
                type="text"
                name="options"
                value={formData.options}
                onChange={onChange}
                placeholder={formData.question_type === 'multiple_choice' 
                  ? "Option 1, Option 2, Option 3" 
                  : "Yes, No (leave empty for default)"}
                className="mt-1 block w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 focus:ring-emerald-500 focus:border-emerald-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
              />
              {(formData.question_type === 'boolean' || formData.question_type === 'yes_no') && (
                <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                  For boolean/yes_no questions, leave empty to use default "Yes, No" options, or specify custom options separated by commas.
                </p>
              )}
            </div>
          )}
          <div className="flex items-center">
            <input
              type="checkbox"
              name="required"
              checked={formData.required}
              onChange={onChange}
              className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 dark:border-gray-600 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900 dark:text-white">Required Field</label>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-4 py-2 bg-emerald-600 dark:bg-emerald-700 border border-transparent rounded-md text-sm font-medium text-white hover:bg-emerald-700 dark:hover:bg-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center"
            >
              {submitting ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Updating...
                </>
              ) : (
                'Update Question'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminQuestionsEditModal;


